import { render, staticRenderFns } from "./SharedManuscriptComment.vue?vue&type=template&id=6764a046&scoped=true&"
import script from "./SharedManuscriptComment.vue?vue&type=script&lang=ts&"
export * from "./SharedManuscriptComment.vue?vue&type=script&lang=ts&"
import style0 from "./SharedManuscriptComment.vue?vue&type=style&index=0&id=6764a046&lang=scss&scoped=true&"
import style1 from "./SharedManuscriptComment.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6764a046",
  null
  
)

export default component.exports